<ng-container *ngIf="newNotifications?.length > 1">
    <div class="notification-alert-box bg-white px-pl-10 px-pr-5 px-py-5 px-w-314 px-h-66 br-2">
        <div class="d-flex flex-row justify-content-between align-items-baseline p-none">
            <div class="text-left fs-14px font-weight-bold">
                {{ newNotifications.length }} new notification{{ newNotifications.length>1?'s':'' }}
            </div>
            <div class="notification-alert-close px-h-14 px-w-14 cursor-pointer" (click)="unsetNew()"></div>
        </div>
        <div class="notification-alert-view px-pt-10">
            <span class="font-size-11 br-2 px-pt-2 cursor-pointer px-px-5 user-select-none" (click)="unsetNew(); showPanel();">
        VIEW NOTIFICATIONS
      </span>
        </div>
    </div>
</ng-container>
<div class="b-black br-2 bg-white" *ngIf="newNotifications?.length === 1">
    <app-notification-item [data]="newNotifications[0]" (view)="doView(newNotifications[0]);" (close)="unsetVisible()" [withinPopup]="true"></app-notification-item>
    <!-- <app-notification-item [data]="newNotifications[0]" (view)="unsetNew()" (close)="unsetVisible()" [withinPopup]="true"></app-notification-item> -->
</div>